exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".lm-columns{position:absolute;height:100%;width:100%;margin-left:0;margin-right:0;padding:0 10px}.lm-columns .col{height:100%;background-color:#fff;margin-right:10px;text-align:center}.lm-columns .col:first-child{border-radius:0 0 0 10px}.lm-columns .col:last-child{border-radius:0 0 10px 0;margin-right:0}", ""]);

// exports
